import React from 'react';

const GoogleMap = ({ embedUrl }) => {
  return (
    <div className="map-container">
      <h2>Kde nás najdete</h2>
      <div className="map-wrapper">
        <iframe 
          title="Lokace školy Maryam na mapě"
          src={embedUrl}
          allowFullScreen
          loading="lazy"
          style={{ 
            width: '100%', 
            height: '450px', 
            border: '0',
            display: 'block'
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default GoogleMap; 